import { Controller } from "@hotwired/stimulus"

const THEME_KEY = "degustation-theme"

export default class extends Controller {
  static targets = [ "sunIcon", "moonIcon" ]

  connect() {
    this.applyTheme(this.resolveInitialTheme())
  }

  toggle(event) {
    event.preventDefault()
    const nextTheme = this.currentTheme() === "dark" ? "light" : "dark"
    this.applyTheme(nextTheme)
    localStorage.setItem(THEME_KEY, nextTheme)
  }

  resolveInitialTheme() {
    const savedTheme = localStorage.getItem(THEME_KEY)
    if (savedTheme === "light" || savedTheme === "dark") return savedTheme
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  }

  currentTheme() {
    return document.documentElement.classList.contains("dark") ? "dark" : "light"
  }

  applyTheme(theme) {
    const isDark = theme === "dark"
    document.documentElement.classList.toggle("dark", isDark)
    this.element.dataset.theme = theme
    this.element.setAttribute("title", `Theme: ${theme}`)
    this.element.setAttribute("aria-label", isDark ? "라이트 모드로 전환" : "다크 모드로 전환")

    if (this.hasSunIconTarget) this.sunIconTarget.classList.toggle("hidden", !isDark)
    if (this.hasMoonIconTarget) this.moonIconTarget.classList.toggle("hidden", isDark)
  }
}
